<style lang="scss">
@import "header.scss";

.header-bar {
    height: 64px;
    background-color: #2b83f9;
    background-image: linear-gradient(143deg, #1D42AB, #2173DC, #1E93FF);
}

.tdui .tdui-page-header-start {
  display: none;
}

.warning-icon {
  color: #f90;
  font-size: 18px;
  margin-right: 6px;
  line-height: 15px;
}
</style>
<template>
    <div :class="['header',$demo?'demo':'']" >
        <!--自适应兼容-->
        <div v-show="isNoLogin" class="header-bar">
            <img src="../../images/logo.png" @click="goCenter()" style="cursor: pointer;">
        </div>
        <!-- 账户，语言切换，通知，二维码 -->
        <div class="header-aside">
          <div v-show="!isNoLogin" id="header-td">
          </div>
          <div class="header-aside-tab" v-if="showTab">
            <ul>
              <li class="active">{{$t('productCenter.title')}}</li>
              <li @click="toAccountPage">{{$t('productCenter.title1')}}</li>
            </ul>
          </div>
        </div>

        <div v-show="!isNoLogin" style="position: absolute; top: 0">
            <img src="../../images/logo.png" @click="goCenter()" style="cursor: pointer;">
        </div>

        <!-- 菜单栏页面切换 -->
        <div class="header-items" v-if="showMenu">
            <div class="header-nav-wrap clear">
              <Button
                icon="ios-menu"
                type="text"
                class="header-nav"
                @click="toggleNav"
              ></Button>
              <img src="../../images/logo-line.svg" class="header-items-line">
            </div>
            <a v-if="navShown.dashboard" @click="jurgeLink('dashboard')" :class="{on: routerFirst === 'dashboard'}">
                <i class="category-icon iconfont icon-analytics"></i>
                <span>我的报表</span>
            </a>
            <a v-if="navShown.analytics" @click="jurgeLink('analytics')" :class="{on: routerFirst === 'analytics'}">
                <i class="category-icon iconfont icon-analytics"></i>
                <span>{{ $t('header.analytics') }}</span>
            </a>
            <a v-if="navShown.gameReport && isGameType" @click="jurgeLink('gameReport')" :class="{on: routerFirst === 'gameReport'}">
                <i class="category-icon iconfont icon-game"></i>
                <span>游戏专项分析</span>
            </a>
        <!-- <a v-link="{path: '/market/' + productid}" :class="{on: routerFirst === 'market'}">
                <img src="../../images/icon-insight.svg">
                <span>{{ $t('header.market') }}</span>
            </a> -->
            <a v-if="navShown.helper" @click="jurgeLink('helper')" :class="{on: routerFirst === 'helper'}">
                <i class="category-icon iconfont icon-Toolbox"></i>
                <span>{{ $t('header.helper') }}</span>
            </a>
            <a v-if="navShown.manage" @click="jurgeLink('manage')" :class="{on: routerFirst === 'manage'}">
                <i class="category-icon iconfont icon-management"></i>
                <span>{{ $t('header.manage') }}</span>
            </a>
        </div>
        <!-- 通用询问窗口，当前页处于设置页面，跳转其他页面时的提示 -->
        <Modal
            v-model="discardChangeShow"
            :mask-closable="false"
            @on-ok="discardChange"
        >
            {{ $t('common.noSave') }} <br/>
            {{ $t('common.isLeave') }}
        </Modal>
    </div>
</template>
<script>
import cookie from 'js-cookie';
import bus from '../../libs/bus';
import util from '../../libs/util';
import navMenu from '../../libs/navigation-menu';
import showModal from '../../config/tip-others-config';
import BaseLib from '../../base/BaseLib';

export default {
  name: 'iHeader',
  data() {
    return {
      email: 'failed',
      lang: bus.lang === 'zh-CN' ? 'EN' : 'CN',
      langList: {
        'zh-CN': 'zh_cn',
        'en-US': 'en_us',
      },
      info: null,
      badge: [],
      navList: navMenu,
      firstPath: {
        dashboard: `/dashboard/main/${this.curProdId}`,
        gameReport: `/gameReport/main/${this.curProdId}`,
        analytics: `/analytics/overview/app/${this.curProdId}`,
        helper: `/helper/err/info/${this.curProdId}`,
        manage: `/manage/overview/info/${this.curProdId}`,
      },
      firstPathFlag: {
        analytics: false,
        helper: false,
        manage: false,
      },
      navShown: {
        dashboard: bus.headerNavShown.dashboard,
        gameReport: bus.headerNavShown.gameReport,
        analytics: bus.headerNavShown.analytics,
        helper: bus.headerNavShown.helper,
        manage: bus.headerNavShown.manage,
      },
      allListShow: false,
      authorizedpage: [],
      oldversionUrl: '',
      menuWidth: 210,
      discardChangeShow: false, // 控制modal框显示隐藏
      toType: '', // 点击的menu所属type

      gameType: [3, 34, 4, 7, 2, 6, 35, 1, 5, 36, 37, 38, 39, 40, 18, 41, 42, 43, 44],
      isGameType: false,
    };
  },
  computed: {
    curProdId() {
      return this.$store.state.transFilterObj.productid;
    },
    isNoLogin() {
      const retVal =
        window.location.hostname === 'szapp.tendcloud.com' ||
        window.location.hostname === 'obg.tendcloud.com' ||
        window.location.hostname === 'localhost';
      return retVal;
    },
    routerFirst() {
      return this.$route.path.split('/')[1];
    },
    showMenu() {
      return (this.$route.path.split('/')[1].indexOf('productCenter') === -1);
    },
    showTab() {
      const path = this.$route.path;
      return path.indexOf('productCenter') > -1 && path.indexOf('createProduct') === -1;
    },
    busLang() {
      this.menuWidth = bus.lang === 'zh-CN' ? 210 : 245;
      return bus.lang;
    },
  },
  watch: {
    busLang() {
      const oLang = this.langList[this.busLang];
      this.oldversionUrl = `${util.baseURL}/app?languagetype=${oLang}`;
    },
  },
  methods: {
    /**
     * 切换左部menu显示
     **/
    toggleNav() {
      bus.$emit('on-nav-toggle');
    },
    // 跳转vue 1.x版的账户授权页面
    toAccountPage() {
      this.$router.push('/account/main/index');
    },
    /* 获取被授权信息 */
    getPageList() {
      const productInfo = this.$store.state.productObj;

      /* 初始化授权状态 */
      this.allListShow = false;
      this.authorizedpage = [];

      if (!productInfo.authorized) {
        this.allListShow = true;
      } else {
        this.authorizedpage = productInfo.authorizedpage ?
          productInfo.authorizedpage.split(',') : [];
        this.authorizedpage.push('authorizeAccount', 'essentialInformation');
      }
    },
    /* 获取header中menu对应的路由 */
    getFirstPath() {
      /* 获取被授权信息 */
      this.getPageList();

      /* 创建者 */
      if (this.allListShow) {
        this.firstPath = {
          dashboard: `/dashboard/main/${this.curProdId}`,
          gameReport: `/gameReport/main/${this.curProdId}`,
          analytics: `/analytics/overview/app/${this.curProdId}`,
          helper: `/helper/err/info/${this.curProdId}`,
          manage: `/manage/overview/info/${this.curProdId}`,
        };
        this.firstPathFlag = {
          analytics: true,
          helper: true,
          manage: true,
        };
      }
      /* 非创建者 */
      for (let i = 0, llen = this.navList.length; i < llen; i += 1) {
        const menuList = this.navList[i];
        const bigMenu = menuList.routerFirst;

        if(bigMenu === 'dashboard') {
          this.firstPath[bigMenu] = `/dashboard/main/${this.curProdId}`;
        } else if(bigMenu === 'gameReport') {
          this.firstPath[bigMenu] = `/gameReport/main/${this.curProdId}`;
        }

        for (let j = 0, ll = menuList.submenu.length; j < ll; j += 1) {
          const oMenu = menuList.submenu[j];
          const menuItem = oMenu.menuItems;
          let hasAuthorize = false;

          for (let m = 0, l = menuItem.length; m < l; m += 1) {
            const pages = menuItem[m].authorizeName;

            for (let n = 0, len = pages.length; n < len; n += 1) {
              const indexInArr = this.authorizedpage.indexOf(pages[n]);

              if (indexInArr > -1) {
                this.firstPath[bigMenu] = `${menuItem[m].key}/${this.curProdId}`;
                this.firstPathFlag[bigMenu] = true;
                hasAuthorize = true;
                break;
              }
            }

            if (hasAuthorize) break;
          }
          if (hasAuthorize) break;
        }
      }
    },
    handleChangeSelect(key) {
      if (key === 'lang') {
        switch (this.$lang) {
          case 'zh-CN':
            this.lang = 'CN';
            bus.$emit('on-change-lang', 'en-US');
            cookie.set('i18next', 'en_us', { domain: '.talkingdata.com' });
            this.menuWidth = 221;
            break;
          case 'en-US':
            this.lang = 'EN';
            bus.$emit('on-change-lang', 'zh-CN');
            cookie.set('i18next', 'zh_cn', { domain: '.talkingdata.com' });
            this.menuWidth = 186;
            break;
          default:
            break;
        }
      }
    },
    getEmail() {
      const self = this;
      const tdppt = cookie.get('tdppt') || 'e2299378-94d5-47cc-8c08-625890d5164c';
      util.ajax.get(`/app/rest/public/email?tdppt=${tdppt}`).then((res) => {
        self.email = res;
      }).catch(() => {
        self.email = 'failed';
      });
    },
    // 询问窗口 确定按钮
    discardChange() {
      this.goPage(this.toType);
    },
    // 判断当前页是否属于设置页面，是则弹出询问窗口，否则跳转
    jurgeLink(type) {
      this.toType = type;
      const showModalList = showModal.isShowModal;
      const currentPath = this.$route.path;
      const filterPath = showModalList.filter(x => currentPath.indexOf(x) > -1);
      if (filterPath.length > 0) {
        this.discardChangeShow = true;
        return;
      }
      BaseLib.checkEmit(this.$root, 'check-change-menu', {
        title: '切换菜单提示',
        callback: () => {
          this.goPage(type);
        },
      });
    },
    /* 点击header跳转 */
    goPage(type) {
      const self = this;
      const path = this.firstPath[type];
      self.$router.push(path);
    },
    // 跳转到产品中心
    goCenter() {
      this.$router.push('/productCenter');
    },
    // 消息中心弹窗
    getInfo() {
      // bus.$emit('on-set-info', this.info);
    },
    // 头部导航公用组件
    headerUI() {
      const self = this;
      const currentEnv = window.location.href;
      let env = '';
      if (currentEnv.indexOf('debug') > -1) {
        env = 'debug';
      } else if (currentEnv.indexOf('local') > -1 || currentEnv.indexOf('szapp') > -1) {
        env = 'dev';
      } else {
        env = 'pro';
      }
      //eslint-disable-next-line
      TDUI.setConfig({
        env,
        tdppt: '4cb4684c-90fe-41a4-b8f1-8d7f9e0a2a28',
        productList: [{
          id: '0', //产品名字，
          theme: 'lightBlue',  //主题
        }],
      });
      //eslint-disable-next-line
      new TDUI.PageHeader('header-td', {
        productId: '0',
        onSettingClick() {
          self.$router.push({
            name: 'account',
          });
        },
      });
    },
    checkGameType() {
      const productObj = this.$store.state.productObj;
      const index = this.gameType.findIndex(item=>{
        return item === productObj.productype;
      })
      this.isGameType = index !== -1
    },
  },
  mounted() {
    bus.productInfo = BaseLib.cloneDeep(this.$store.state.productObj)

    if(window.location.hostname === 'www.talkingdata.com'){
      this.headerUI();
    }
    bus.$on('on-app-change-nav', () => {
      this.getFirstPath();
      this.checkGameType();
    });
    bus.$on('header-nav-shown', () => {
      this.navShown = bus.headerNavShown;
    });
    bus.$on('on-read-mark', (info) => {
      this.badge = info.filter(x => (x.status * 1) === 0);
    });
    const oLang = this.langList[this.busLang];
    this.oldversionUrl = `${util.baseURL}/app?languagetype=${oLang}`;
    this.getFirstPath();
    this.checkGameType();
    this.getEmail();
  },
};
</script>
